import React, { useContext, useEffect, useState } from 'react';
import { SprawneMiastoContext } from '../../../../components/SprawneMiastoContext';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import api, { retrieveApiErrorCode } from '../../../../utils/api';
import { TextField } from '../../../../components/Form';
import Modal from '../../../../components/Modal';
import { MdDeleteOutline } from 'react-icons/md';
import Cookies from 'js-cookie';

export default function DeleteAccount() {
    const { t } = useTranslation();
    const [deleteAccount, setDeleteAccount] = useState<boolean>(false);
    return (
        <div>
            <RemoveModal show={deleteAccount} onClose={() => setDeleteAccount(false)} />

            <button
                className={'hover-effect py-4 text-red-500 transition-all'}
                onClick={() => setDeleteAccount(true)}>
                {t('translation:MY_ACCOUNT.PROFILE.REMOVE_ACCOUNT')}
            </button>
        </div>
    );
}

function RemoveModal(props: { show: boolean; onClose: () => void }) {
    const { t } = useTranslation();
    const [phase, setPhase] = useState<0 | 1>(0);
    const Context = useContext(SprawneMiastoContext);
    useEffect(() => {
        setPhase(0);
    }, [props.show]);
    return (
        <Modal show={props.show} onClose={props.onClose} width={650} showClose={false}>
            <div className={'p-4'}>
                <h2 className={'mb-3'}>{t('translation:MY_ACCOUNT.PROFILE.REMOVING_ACCOUNT')}</h2>
                {phase === 0 && (
                    <>
                        <p className={'text-sm text-gray-500'}>
                            {t('translation:MY_ACCOUNT.PROFILE.REMOVE_DISCLAIMER')}
                        </p>
                        <div className={'mt-3 flex justify-around gap-5'}>
                            <button
                                onClick={props.onClose}
                                className={
                                    'btn-outlined flex-1 justify-center border-gray-400 text-center text-gray-500 hover:bg-gray-400 hover:text-white'
                                }>
                                {t('translation:MY_ACCOUNT.PROFILE.CANCEL')}
                            </button>
                            <button
                                onClick={() => setPhase(1)}
                                className={
                                    'btn-filled flex-1 justify-center bg-red-500 text-white ring-red-500/50'
                                }>
                                {t('translation:MY_ACCOUNT.PROFILE.UNDERSTAND')}
                            </button>
                        </div>
                    </>
                )}
                {phase === 1 && (
                    <>
                        <p className={'text-sm text-gray-500'}>
                            {t('translation:MY_ACCOUNT.PROFILE.REMOVE_DISCLAIMER_2')}
                        </p>
                        <Formik
                            initialValues={{
                                password: '',
                            }}
                            validationSchema={Yup.object().shape({
                                password: Yup.string().required(
                                    t('translation:ERRORS.WEB_VALIDATION.0') as string,
                                ),
                            })}
                            onSubmit={async (values, formikHelpers) => {
                                const response = await api.delete('users/me/delete', {
                                    body: JSON.stringify(values),
                                });
                                if (!response.ok) {
                                    const errorCode = await retrieveApiErrorCode(response);
                                    if (errorCode === false) return;
                                    return formikHelpers.setFieldError(
                                        'password',
                                        t('translation:ERRORS.API.2003') as string,
                                    );
                                }
                                Cookies.remove('sm_auth');
                                await Context?.fetchUser();
                                props.onClose();
                            }}>
                            {(fProps) => (
                                <Form className={'mt-4'}>
                                    <TextField
                                        placeholder={'Hasło'}
                                        type="password"
                                        formik={fProps}
                                        name={'password'}
                                    />
                                    <div className={'mt-4 flex justify-around gap-5'}>
                                        <button
                                            type={'button'}
                                            onClick={props.onClose}
                                            className={
                                                'btn-outlined flex-1 justify-center border-gray-400 text-center text-gray-500 hover:bg-gray-400 hover:text-white'
                                            }>
                                            {t('translation:MY_ACCOUNT.PROFILE.CANCEL')}
                                        </button>
                                        <button
                                            type={'submit'}
                                            onClick={() => setPhase(1)}
                                            className={
                                                'btn-filled flex-1 justify-center bg-red-500 text-white ring-red-500/50'
                                            }>
                                            <MdDeleteOutline className={'text-2xl'} />
                                            {t('translation:MY_ACCOUNT.PROFILE.REMOVE_ACCOUNT')}
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </>
                )}
            </div>
        </Modal>
    );
}
